import {
  GOOGLE_TRANSLATE_CHANGE_LANGUAGE,
  GOOGLE_TRANSLATE_READY,
  GOOGLE_TRANSLATE_RESET,
  INIT_GOOGLE_TRANSLATE,
} from 'volto-google-translate/constants';

export function initGoogleTranslate() {
  return {
    type: INIT_GOOGLE_TRANSLATE,
  };
}

export function googleTranslateReady() {
  return {
    type: GOOGLE_TRANSLATE_READY,
  };
}
export function changeLanguage(newLanguage) {
  return {
    type: GOOGLE_TRANSLATE_CHANGE_LANGUAGE,
    language: newLanguage,
  };
}

export function reset() {
  return {
    type: GOOGLE_TRANSLATE_RESET,
  };
}
